<div class="button-container">
    <p-button
        (onClick)="changeZoomManual()"
        [pTooltip]="isZoomable ? 'Bloquear zoom' : 'Desbloquear zoom'"
        [tooltipPosition]="'bottom'"
        [iconPos]="'left'"
        [icon]="isZoomable ? 'pi pi-lock-open' : 'pi pi-lock'"
    ></p-button>
    <p-button
        (onClick)="center()"
        [pTooltip]="'Centrar Nodos'"
        [tooltipPosition]="'bottom'"
        [iconPos]="'left'"
        [icon]="'pi pi-window-maximize'"
    ></p-button>
    <p-button
        (onClick)="zoomIn()"
        [pTooltip]="'Acercar'"
        [tooltipPosition]="'bottom'"
        [iconPos]="'left'"
        [icon]="'pi pi-plus'"
    ></p-button>
    <p-button
        (onClick)="zoomOut()"
        [pTooltip]="'Alejar'"
        [tooltipPosition]="'bottom'"
        [iconPos]="'left'"
        [icon]="'pi pi-minus'"
    ></p-button>
    <p-button
        (onClick)="download()"
        [pTooltip]="'Descargar imagen'"
        [tooltipPosition]="'bottom'"
        [iconPos]="'left'"
        [icon]="'pi pi-download'"
    ></p-button>
</div>
